export const paymentTypes = {
  CREDITCARD: "creditCard",
  BIT: "bit",
};
